import { z } from 'zod';

export const createAccountSchema = z.object({
  name: z.string().min(1, 'Account name is required').max(100, 'Account name too long'),
  logo: z.string().min(1, 'Logo URL is required'),
  municipality: z.string().min(1, 'Municipality is required').max(100, 'Municipality name too long'),
  status: z.enum(['active', 'inactive', 'suspended', 'trial']).optional().default('active'),
  primaryDomain: z.url('Invalid URL format').optional().or(z.literal('')),
});

export type CreateAccountFormData = z.infer<typeof createAccountSchema>;

export type CreateAccountResponse = {
  account: {
    id: string;
    name: string;
    logo: string;
    municipality: string;
    status: 'ACTIVE' | 'INACTIVE';
    primaryDomain?: string;
  };
};
